import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import "./style.scss";
import "./print-style.css";
import qrcode from "./images/qr.png";
import { baseUrl } from '../../common/constants';
import { toast } from "react-toastify";
import Loading from '../../components/Loader/Loading';
import _axios from '../../utils/api/_axios';
import { Button } from 'antd';
import moment from 'moment';

const Invoice = () => {
    const { patientId, claimId } = useParams();
    const [report, setReport] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [dob, setDob] = useState(new Date());
    const [doi, setDoi] = useState(new Date());
    const [officeDetails, setOfficeDetails] = useState("");
    const [loading, setLoading] = useState(false);
    const rows = Array.from({ length: 12 }, (_, index) => String.fromCharCode(65 + index));
    const middle6Rows = Array.from({ length: 6 }, (_, index) => index);
    let counter = 0;

    const setNatureOfIllness = (natureOfIllness) => {
        const natureOfIllnessElements = document.querySelectorAll(".in24E");
        natureOfIllnessElements.forEach((element) => {
            element.value = natureOfIllness[element.dataset.label];
        });
    }
    const downloadCsvForCarisk = (claimId) => async () => {
        setLoading(true);
        await handleSaveInvoice(false, false);
        try {
            const response = await axios.post(`${baseUrl}/csv/referralCsvGeneration/${claimId}/carisk-csv`, {
                responseType: 'blob',
                headers: {
                    'Authorization': localStorage.getItem("token")
                }
            });
            console.log('CSV response:', response);
            const csvBlob = new Blob([response.data], { type: 'text/csv' });
            const csvUrl = URL.createObjectURL(csvBlob);
            const a = document.createElement('a');
            a.href = csvUrl;
            a.download = `Carisk_claim_${claimId}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            // window.open(csvUrl, '_blank');
        } catch (error) {
            console.error('Error downloading CSV:', error);
            toast.error("Failed to download CSV for Carisk.");
        } finally {
            setLoading(false);
        }
    };
    const fetchReport = async () => {
        try {
            const response = await _axios.get(`${baseUrl}/dashboard/report/patient/${patientId}/claim/${claimId}`);
            const reportData = response.data.payload[0];
            setReport(reportData);
            setIsLoading(false);
            setDob(new Date(reportData.patientDetails.dateOfBirth));
            setDoi(new Date(reportData.dateOfInjury));
            setOfficeDetails(getOfficeAddressDetails(reportData?.appointment))
        } catch (error) {
            console.error("Error fetching patient:", error);
            toast.error(error.message);
        }
    };

    const map = (invoiceReport) => {
        return {
            "updateProperty": "invoiceReport",
            "value": invoiceReport
        }
    }

    const getOfficeAddressDetails = (appointment) => {
        if(appointment) {
            const { officeId, officeAddress } = appointment;

            if (officeId && officeAddress) {
                const { address, phone, fax } = officeAddress;
                if (address) {
                    return {
                    officeAddress: address,
                    officePhone: phone || "",
                    officeFax: fax || "",
                    };
                }
            }
        }
        return {
            officeAddress: "",
            officePhone: "",
            officeFax: "",
        };
    };
    const validateMiddleRows = () => {
        const totalRows = 6;
        let hasFullRow = false;
        let hasPartialRow = false;

        for (let rowIndex = 0; rowIndex < totalRows; rowIndex++) {
            const inputs = document.querySelectorAll(`.middle6_${rowIndex} input:not([data-exclude="true"])`);
            if (!inputs.length) continue; // in case some row has no inputs at all

            let filledCount = 0;
            let emptyCount = 0;

            inputs.forEach(input => {
                if (input.value.trim() === "") {
                    emptyCount++;
                } else {
                    filledCount++;
                }
            });

            // Completely empty row → OK, ignore it
            if (filledCount === 0 && emptyCount > 0) {
                continue;
            }

            // Completely filled row
            if (filledCount > 0 && emptyCount === 0) {
                hasFullRow = true;
            }
            // Partially filled row → invalid (mark errors)
            if (filledCount > 0 && emptyCount > 0) {
                hasPartialRow = true;

                // Add error class ONLY to empty inputs in the partial row
                inputs.forEach(input => {
                    if (input.value.trim() === "") {
                        input.classList.add("err-msg");
                    }
                });
            }
        }

        const isValid = hasFullRow && !hasPartialRow;
        return isValid;
    }
    const addErrorMessageClass = (element) => {
        //element.parentElement.classList.add("err-msg");
        //if(element.classList && !element.classList.contains("err-msg")) {
            element.classList.add("err-msg");
        //}
            
    }
    const removeErrorMessageClass = () => {
        const elements = document.querySelectorAll(".err-msg");
        elements.forEach((el) => el.classList.remove("err-msg"));
    }
    const validateFormBeforeSave = () => {
        removeErrorMessageClass();
        const fieldsToValidate = [
                {
                    type: "checkbox",
                    fields: ["chk0a1", "chk0a2", "chk0a3", "chk0a4", "chk0a5", "chk0a6", "chk0a7"],
                    error: "Please select at least one insurance type in field 1."
                },
                {
                    type: "input",
                    fields: ["1a"],
                    error: "Please enter Insured's I.D. Number in field 1a."
                },
                {
                    type: "input",
                    fields: ["4"],
                    error: "Please enter Insured's Name in field 4."
                },
                {
                    type: "input",
                    fields: ["7a12"],
                    error: "Please enter Insured's Address in field 7."
                },
                {
                    type: "input",
                    fields: ["7cty"],
                    error: "Please enter Insured's City in field 7."
                },
                {
                    type: "input",
                    fields: ["7stt"],
                    error: "Please enter Insured's State in field 7."
                },
                {
                    type: "input",
                    fields: ["7zip"],
                    error: "Please enter Insured's Zip Code in field 7."
                },
                {
                    type: "input",
                    fields: ["2"],
                    error: "Please enter Patient's name in field 2."
                },
                {
                    type: "input",
                    fields: ["3mm", "3dd", "3yy"],
                    error: "Please enter Patient's Birth Date in field 3."
                },
                {
                    type: "checkbox",
                    fields: ["3mal", "3fem"],
                    error: "Please enter Patient's Gender in field 3."
                },
                {
                    type: "input",
                    fields: ["5"],
                    error: "Please enter Patient's Address in field 5."
                },
                {
                    type: "input",
                    fields: ["5city"],
                    error: "Please enter Patient's City in field 5."
                },
                {
                    type: "input",
                    fields: ["5state"],
                    error: "Please enter Patient's State in field 5."
                },
                {
                    type: "input",
                    fields: ["5zip"],
                    error: "Please enter Patient's Zip Code in field 5."
                },
                {
                    type: "checkbox",
                    fields: ["chk10ano", "chk10ayes"],
                    error: "Please select at least one employment status."
                },
                {
                    type: "checkbox",
                    fields: ["chk10byes", "chk10bno"],
                    error: "Please select at least one auto accident status."
                },
                {
                    type: "checkbox",
                    fields: ["chk10cyes", "chk10cno"],
                    error: "Please select at least one other accident status."
                },
                {
                    type: "input",
                    fields: ["11"],
                    error: "Please enter Patient's Insured policy in field 11."
                },
                {
                    type: "input",
                    fields: ["11b"],
                    error: "Please enter other claim id in field 11."
                },
                {
                    type: "input",
                    fields: ["14mm", "14dd", "14yy"],
                    error: "Please enter Date of Current Illness in field 14."
                },
                {
                    type: "checkbox",
                    fields: ["chk25ssn", "chk25ein"],
                    error: "Please select at least one SSN or EIN option."
                },
                {
                    type: "input",
                    fields: ["26"],
                    error: "Please enter patient's account number in field 26."
                },
                {
                    type: "checkbox",
                    fields: ["chk27y", "chk27n"],
                    error: "Please select at least one of Accept assignment Yes or No option."
                },
                {
                    type: "input",
                    fields: ["28"],
                    error: "Please enter total charges in field 28."
                },
                {
                    type: "input",
                    fields: ["29"],
                    error: "Please enter amount paid in field 29."
                },
                {
                    type: "input",
                    fields: ["31sign"],
                    error: "Please enter signature in field 31."
                },
                {
                    type: "input",
                    fields: ["31signdate"],
                    error: "Please enter sign date in field 31."
                },
                {
                    type: "input",
                    fields: ["32office", "32address", "32npi"],
                    error: "Please enter all fields in section 32."
                },
                {
                    type: "input",
                    fields: ["33a"],
                    error: "Please enter billing provider information in section 33."
                },
                {
                    type: "input",
                    fields: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
                    error: "Please enter nature of illness in section 33."
                }
            ];

        let isValid = true;
        const errorMessages = [];
        for (let item of fieldsToValidate) {
            if (item.type === "checkbox") {
                let isAnyChecked = false;
                for (let field of item.fields) {
                    const element = document.querySelector(`input[data-be="${field}"],input[data-val="${field}"]`);
                    if (element && element.checked) {
                        isAnyChecked = true;
                        // addErrorMessageClass(element);
                        break;
                    }
                }
                if (!isAnyChecked) {
                    errorMessages.push(item.error);
                    isValid = false;
                }
            } else if (item.type === "input") {
                let isAllInputFilled = true;
                for (let field of item.fields) {
                    const element = document.querySelector(`input[data-be="${field}"],input[data-val="${field}"]`);
                    if (element && !element.value.trim()) { // && element.dataset.required === "input" 
                        isAllInputFilled = false;
                        addErrorMessageClass(element);
                        break;
                    }
                }
                if (!isAllInputFilled) {
                    errorMessages.push(item.error);
                    isValid = false;
                }
            }
        }
        const isIllnessValid = Array.from(document.querySelectorAll(".in24E")).some(input => input.value.trim() !== "");
        if (!isIllnessValid) {
            addErrorMessageClass(document.querySelector(".illness"));
            errorMessages.push("Please enter at least one Nature of Illness in section 33.");
            isValid = false;
        }
        
        const isAtleastOneMiddle6Filled = validateMiddleRows();

        if (!isAtleastOneMiddle6Filled) {
            errorMessages.push("Please enter at least one complete row in Middle 6 section.");
            isValid = false;
        }

        if (errorMessages.length > 0) {
            toast.error(
            <div>
                {
                    errorMessages.map((msg, i) => (
                        <div key={i}>{`${i + 1}: ${msg}`}</div>
                    ))
                }
            </div>, { autoClose: 10000 });
        }

        return isValid;
    };
    const handleSaveInvoice = async (saveAndPrint = false, loadAfterSave = true) => {
        const isFormValid = validateFormBeforeSave();
        
        if (!isFormValid) {
            return;
        }

        const natureOfIllness = document.querySelectorAll(".in24E");
        const natureOfIllnessArray = {};
        natureOfIllness.forEach((element) => {
            natureOfIllnessArray[element.dataset.label] = element.value;
        });
        const middle6Data = [];
        middle6Rows.map((rowIndex) => {
            const middle6Inputs = document.querySelectorAll(`.middle6_${rowIndex} input`);
            const middle6InputsArr = [];
            middle6Inputs.forEach((element, key) => {
                middle6InputsArr.push(element.value);
            });
            middle6Data.push(middle6InputsArr);
        });

        const allOtherProps = {};
        const allOtherPropsElements = document.querySelectorAll("input[data-be]");
        allOtherPropsElements.forEach((element) => {
            const key = element.dataset.be;
            if(key) {
                if(key.startsWith("chk")) {
                    allOtherProps[key] = element.checked ? true : false;
                } else {
                    allOtherProps[key] = element.value || "";
                }
            }
        });

        const invoiceReport = {
            natureOfIllness: natureOfIllnessArray,
            middle6Rows: middle6Data,
            allOtherProps: allOtherProps
        };

        return new Promise((resolve, reject) => {
            _axios.put(`${baseUrl}/patients/${patientId}/claims/${claimId}`, map(invoiceReport), {
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
            })
            .then((res) => {
            if (saveAndPrint) {
                window.print();
            } else {
                if (loadAfterSave) {
                window.location.reload();
                }
            }
            resolve(res);
            })
            .catch((err) => {
            console.error(err);
            reject(err);
            });
        });
    };

    const handleSendToCarisk = async() =>{
        await handleSaveInvoice(false);
        await _axios.put(`${baseUrl}/patients/${patientId}/claims/${claimId}/status`, {status: "Pending carisk transfer"}, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }

    const handleSaveAsPdf = async () => {
        setLoading(true);
        let htmlContent = document.documentElement.outerHTML;
        htmlContent = htmlContent.replaceAll('href="/', `href="${window.location.origin}/`);
        htmlContent = htmlContent.replaceAll('src="/', `src="${window.location.origin}/`);
        htmlContent = htmlContent.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
        const url = `${baseUrl}/patients/generate-pdf`
        const pageUrl = window.location.href;
        try {
            const response = await axios.post(url, { pageUrl }, { responseType: 'blob', headers: { 'Authorization': localStorage.getItem("token") } });
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            const a = document.createElement('a');
            a.href = pdfUrl;
            a.download = 'invoice.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating or opening PDF:', error);
        }
        finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if(!report) {
            fetchReport();
        } else {
            if(report.invoiceReport) {
                if (report.invoiceReport.natureOfIllness) {
                    setNatureOfIllness(report.invoiceReport.natureOfIllness);
                }
                if (report.invoiceReport.middle6Rows) {
                    const middle6Data = report.invoiceReport.middle6Rows;
                    middle6Rows.map((rowIndex) => {
                        const middle6Inputs = document.querySelectorAll(`.middle6_${rowIndex} input`);
                        middle6Inputs.forEach((element, key) => {
                            element.value = middle6Data[rowIndex][key];
                        });
                    });
                }
                if (report.invoiceReport.allOtherProps) {
                    const allOtherProps = report.invoiceReport.allOtherProps;
                    const allOtherPropsElements = document.querySelectorAll("input[data-be]");
                    allOtherPropsElements.forEach((element) => {
                        const key = element.dataset.be;
                        if(key) {
                            if(key.startsWith("chk")) {
                                element.checked = allOtherProps[key];
                            } else {
                                element.value = allOtherProps[key] || "";
                            }
                        }
                    });
                }
            }
        }
    }, [report]);
    return (
        <>
            {
                isLoading ? (
                    <div className="circularLoader">
                        <Loading isCircular={true} />
                    </div>
                )
                    : (
                        report && (
                            <div className='invoiceModule'>
                                <div className="container">
                                    <form className="contact" method="post">
                                        <div className="top">
                                            <div className="topleft">
                                                <img id="qrcode" src={qrcode} alt="" />
                                                <p id="L-p">HEALTH INSURANCE CLAIM FORM</p>
                                                <p className="heading-subtitle">APPROVED BY NATIONAL UNIFORM CLAIM COMMITTEE (NUCC) 02/12</p>
                                            </div>
                                            <div className="topright">
                                                <input type="text" value="Right Script Services Inc." />
                                                <input type="text" value="PO Box 1225" />
                                                <input type="text" value="Webster NY 14580" />
                                                <input type="text" value="585-738-8317" />
                                            </div>
                                        </div>
                                        <div className="topPICA d-f-s-b">
                                            <div className="leftPICA d-f">
                                                <div className="PICA">
                                                </div>
                                                <div className="PICA">
                                                </div>
                                                <div className="PICA">
                                                </div>
                                                <p>PCIA</p>
                                            </div>
                                            <div className="t-t-x-2 rightPICA d-f">
                                                <p>PCIA</p>
                                                <div className="PICA">
                                                </div>
                                                <div className="PICA">
                                                </div>
                                                <div className="PICA">
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 border d-f">
                                            <div className="coll60 padding-top-2px p-d-l-2 border-right d-f">
                                                <div className="w8-5">
                                                    <p>1. MEDICARE</p>
                                                    <div className="inside8-5">
                                                        <input type="checkbox" data-be="chk0a1" name='category-bg'/>
                                                        <p className="Italic">(Medicare#)</p>
                                                    </div>
                                                </div>
                                                <div className="w8-5">
                                                    <p>MEDICAID</p>
                                                    <div className="inside8-5">
                                                        <input type="checkbox" data-be="chk0a2" name='category-bg'/>
                                                        <p className="Italic">(Medicaid#)</p>
                                                    </div>
                                                </div>
                                                <div className="w8-5">
                                                    <p>TRICARE</p>
                                                    <div className="inside8-5">
                                                        <input type="checkbox" data-be="chk0a3" name='category-bg'/>
                                                        <p className="Italic">(ID#/DoD#)</p>
                                                    </div>
                                                </div>
                                                <div className="w8-5">
                                                    <p>CHAMPVA</p>
                                                    <div className="inside8-5">
                                                        <input type="checkbox" data-be="chk0a4" name='category-bg'/>
                                                        <p className="Italic">(Member ID#)</p>
                                                    </div>
                                                </div>
                                                <div className="w8-5 me-10">
                                                    <p>GROP<br />HEALTH PLAN</p>
                                                    <div className="inside8-5">
                                                        <input type="checkbox" data-be="chk0a5" name='category-bg'/>
                                                        <p className="Italic">(ID#)</p>
                                                    </div>
                                                </div>
                                                <div className="w8-5">
                                                    <p>FECA<br />BLKLUNG</p>
                                                    <div className="inside8-5">
                                                        <input type="checkbox" data-be="chk0a6" name='category-bg'/>
                                                        <p className="Italic">(ID#)</p>
                                                    </div>
                                                </div>
                                                <div className="w8-5">
                                                    <p>OTHER</p>
                                                    <div className="inside8-5">
                                                        <input type="checkbox"data-be="chk0a7" name='category-bg'/>
                                                        <p className="Italic">(ID#)</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="coll40  p-d-l-2 ">
                                                <div className="inside-d-f-s-b padding-top-2px">
                                                    <p>1a. INSURED'SI.D. NUMBER</p>
                                                    <p className="margin-right-30px">(For Program in Item 1)</p>
                                                </div>
                                                <input className="margin-top-10 in" type="text" data-be="1a" />
                                            </div>
                                        </div>
                                        <div className="row100  border-left border-right border-bottom d-f">
                                            <div className="coll40 p-d-l-2 padding-top-2px ">
                                                <p>2. PATIENT'S NAME(Last Name, First Name, Middle Initial)</p>
                                                <input className="in" type="text" data-val="2" value={`${report?.patientDetails?.lastName}, ${report?.patientDetails?.firstName}`} />
                                            </div>
                                            <div className="coll20 padding-top-2px p-d-l-2 border-left">
                                                <div className="inside-d-f-s-b">
                                                    <p>3. PATIENT BIRTH DATE</p>
                                                    <p className="margin-right-15px">SEX</p>
                                                </div>
                                                <div className="inside-d-f-s-b">
                                                    <input id="indate-b-r" className="number-2-digit" data-val="3mm" placeholder="MM" type="text" value={dob?.getMonth() + 1} />
                                                    <input id="indate" className="number-2-digit" data-val="3dd" placeholder="DD" type="text" value={dob?.getDate()} />
                                                    <input id="indate-b-l" data-val="3yy" placeholder="YY" type="text" value={dob ? String(dob.getFullYear()).slice(-2) : ''} />
                                                    <div className="d-f-s-b a-i-c">
                                                        <p>M</p>
                                                        <input type="checkbox" data-val="3mal" checked={report.patientDetails.gender === "male"} readOnly={true} />
                                                    </div>
                                                    <div className="d-f-s-b a-i-c">
                                                        <p>F</p>
                                                        <input type="checkbox" data-val="3fem" checked={report.patientDetails.gender === "female"} readOnly={true} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="coll40 p-d-l-4 padding-top-2px  border-left ">
                                                <p>4. INSURED'S NAME (Last Name, First Name, Middle Initial)</p>
                                                <input className="in" type="text" data-be="4" />
                                            </div>
                                        </div>
                                        <div className="row100 d-f border-bottom border-right border-left ">
                                            <div className="coll40 padding-top-2px p-d-l-2 ">
                                                <p className="p-d-l-2">5. PATIENT'S ADDRESS (No, Street)</p>
                                                <input className="in" type="text" data-val="5" value={`${report?.patientDetails?.patient_address1}, ${report?.patientDetails?.patient_address2}`} />
                                            </div>
                                            <div className="coll20 padding-top-2px p-d-l-2  border-left ">
                                                <p id="font-sz" className="padding-left-1px">6. PATIENT RELATIONSHIP TO INSURED</p>
                                                <div className="d-f-s-a padding-top-2px fs10p">
                                                    <div className="d-f">
                                                        <p className="margin-top-4px" id="font-sz">Self</p>
                                                        <input className="margin-right-0 margin-left-0" type="checkbox" checked={report.adjusterInfo.insured.patientRelationshipToInsured === "self"}/>
                                                    </div>
                                                    <div className="d-f-s-a">
                                                        <p className="margin-top-4px" id="font-sz">Spouse</p>
                                                        <input className="margin-right-0 margin-left-0" type="checkbox" checked={report.adjusterInfo.insured.patientRelationshipToInsured === "spouse"}/>
                                                    </div>
                                                    <div className="d-f-s-a ">
                                                        <p className="margin-top-4px" id="font-sz">Child</p>
                                                        <input className="margin-right-0 margin-left-0" type="checkbox" checked={report.adjusterInfo.insured.patientRelationshipToInsured === "child"}/>
                                                    </div>
                                                    <div className="d-f-s-a ">
                                                        <p className="margin-top-4px" id="font-sz">Other</p>
                                                        <input className="margin-right-0 margin-left-0" type="checkbox" checked={report.adjusterInfo.insured.patientRelationshipToInsured === "other"} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="coll40  padding-top-2px p-d-l-4 border-left">
                                                <p>7. INSURED'S ADDRESS(No, Street)</p>
                                                <input className="in" type="text" data-be="7a12"/>
                                            </div>
                                        </div>
                                        <div className="row100 d-f padding-right-05px border-bottom border-right ">
                                            <div className="row40 ">
                                                <div className="row100 d-f border-left border-bottom">
                                                    <div className="coll70 padding-top-2px  border-right">
                                                        <p className="p-d-l-2">CITY</p>
                                                        <input className="in" type="text" data-val="5city" value={`${report?.patientDetails?.patient_city}`} />
                                                    </div>
                                                    <div className="coll30 padding-top-2px  ">
                                                        <p className="p-d-l-2">STATE</p>
                                                        <input className="in" type="text" data-val="5state" value={`${report?.patientDetails?.patient_state}`} />
                                                    </div>
                                                </div>
                                                <div className="row100 d-f border-left">
                                                    <div className="coll40 padding-top-2px  ">
                                                        <p className="p-d-l-2">ZIP CODE</p>
                                                        <input className="in" type="text" data-val="5zip" value={`${report?.patientDetails?.patient_zip}`} />
                                                    </div>
                                                    <div className="coll60 padding-top-2px border-left">
                                                        <p className="p-d-l-2">TELEPHONE (Include Area Code)</p>
                                                        <div className="inside-d-f">
                                                            <input className="t-t-x-2" id="in-area-code" type="text" />
                                                            <input className="in" type="text" value={`${report?.patientDetails?.mobile}`}/>
                                                        </div>
                                                    </div>
                                                </div>?
                                            </div>
                                            <div className="row20 border-left border-right padding-top-2px ">
                                                <p className="p-d-l-2 ">8. RESERVED FOR NUCC USE</p>
                                                <input className="h100 in" type="text" data-be="8" />
                                            </div>
                                            <div className="row40">
                                                <div className="row100 d-f border-bottom">
                                                    <div className="coll70 padding-top-2px border-right ">
                                                        <p className="p-d-l-2">CITY</p>
                                                        <input className="in" type="text" data-be="7cty"/>
                                                    </div>
                                                    <div className="coll30 padding-top-2px  ">
                                                        <p className="p-d-l-2">STATE</p>
                                                        <input className="in" type="text" data-be="7stt"/>
                                                    </div>
                                                </div>
                                                <div className="row100 d-f ">
                                                    <div className="coll40 padding-top-2px border-right">
                                                        <p className="p-d-l-2">ZIP CODE</p>
                                                        <input className="in" type="text" data-be="7zip"/>
                                                    </div>
                                                    <div className="coll60 padding-top-2px ">
                                                        <p className="p-d-l-2">TELEPHONE (Include Area Code)</p>
                                                        <div className="inside-d-f">                          
                                                            <input className="t-t-x-2" id="in-area-code" type="text" data-be="7cod" />
                                                            <input className="in" type="text" data-be="7phn"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 border-bottom border-left border-right d-f">
                                            <div className="row40 border-right">
                                                <div className="row100  padding-top-2px border-bottom ">
                                                    <p className="p-d-l-2">9. OTHER INSURED'S NAME (Last Name, First Name, Middle Initial)</p>
                                                    <input className="in" type="text"  data-be="9" />
                                                </div>
                                                <div className="row100 padding-top-2px border-bottom ">
                                                    <p className="p-d-l-2">a. OTHER INSURED'S POLICY OR GROUP NUMBER</p>
                                                    <input className="in" type="text" data-be="9a" />
                                                </div>
                                                <div className="row100 padding-top-2px border-bottom ">
                                                    <p className="p-d-l-2">b. RESERVED FOR NUCC USE</p>
                                                    <input className="in" type="text" data-be="9b" />
                                                </div>
                                                <div className="row100 padding-top-2px  ">
                                                    <p className="p-d-l-2 ">c. RESERVED FOR NUCC USE</p>
                                                    <input className="mt5 in" type="text" data-be="9c" />
                                                </div>
                                            </div>
                                            <div className="row20  padding-top-1px  p-d-l-1 ">
                                                <p className="padding-bottom-2px padding-top-2px" id="font-size-7px">10. IS PATIENT'S CONDITION RELARED TO:</p>
                                                <p className="padding-top-4px" id="font-size-7px">a. EMPLOYMENT ? (Current or Previous)  </p>
                                                <div className="inside-d-f-n-jb j-c-c a-i-c mt0">
                                                    <input type="checkbox" data-val="chk10ayes" checked={report?.adjusterInfo?.insured?.employmentAccident === "Yes"}/>
                                                    <p className=" mt5">YES</p>
                                                    <input type="checkbox" data-val="chk10ano" checked={report?.adjusterInfo?.insured?.employmentAccident === "No"}/>
                                                    <p className="mt5">NO</p>
                                                </div>
                                                <p className="mb0 mt0">b. AUTO ACCIDENT?</p>
                                                <div className="inside-d-f-n-jb j-c-c a-i-c">
                                                    <input type="checkbox" data-val="chk10byes" checked={report?.adjusterInfo?.insured?.autoAccident === "Yes"}/>
                                                    <p className="mt5">YES</p>
                                                    <input type="checkbox" data-val="chk10bno" checked={report?.adjusterInfo?.insured?.autoAccident === "No"}/>
                                                    <p className="mt5">NO</p>
                                                    <div className="inside-d-b t-a-c">
                                                        <p>PLACE(State)</p>
                                                        <input id="in-PLACE" type="text" />
                                                    </div>
                                                </div>
                                                <p>c. OTHER ACCIDENT?</p>
                                                <div className="inside-d-f-n-jb j-c-c a-i-c">
                                                    <input type="checkbox" data-val="chk10cyes" checked={report?.adjusterInfo?.insured?.otherAccident === "Yes"}/>
                                                    <p className="mt5">YES</p>
                                                    <input type="checkbox" data-val="chk10cno" checked={report?.adjusterInfo?.insured?.otherAccident === "No"}/>
                                                    <p className="mt5">NO</p>
                                                </div>
                                            </div>
                                            <div className="row40 border-left p-d-l-1">
                                                <div className="row100 padding-top-2px border-bottom ">
                                                    <p className="p-d-l-2">11. INSURED'S POLICY GROP OR FECA NUMBER</p>
                                                    <input className="in" data-val="11" type="text" value={`${report?.claimNumber}`}/>
                                                </div>
                                                <div className="row100 border-bottom">
                                                    <div className="inside-d-f-s-b ">
                                                        <p className="padding-top-1px">a. INSURED'S DATE OF BIRTH</p>
                                                        <p id="margin-right-15px" className="padding-top-2px">SEX</p>
                                                    </div>
                                                    <div className="inside-d-f-s-b">
                                                        <input id="indate-b-r" placeholder="MM" type="text" data-be="11am"/>
                                                        <input id="indate" placeholder="DD" type="text" data-be="11ad"/>
                                                        <input id="indate-b-l" placeholder="YY" type="text" data-be="11ay" />
                                                        <div className="d-f-s-b a-i-c">
                                                            <p>M</p>
                                                            <input type="checkbox" name="gender" data-be="chk11agm"/>
                                                        </div>
                                                        <div className="d-f-s-b a-i-c">
                                                            <p>F</p>
                                                            <input type="checkbox" name="gender" data-be="chk11agf"/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row100  padding-top-2px border-bottom ">
                                                    <p className="padding-top-1px">b. OTHER CLAIM ID (Designated by NUCC)</p>
                                                    <div className="inside-d-f-n-jb">
                                                        <input id="inID" type="text" value={`Y4`}/>
                                                        <input className="in" data-val="11b" type="text" value={`${report?.adjusterInfo?.insured?.otherClaimId}`}/>
                                                    </div>
                                                </div>
                                                <div className="row100  ">
                                                    <p className="padding-top-1px">c. INSURANCE PLAN NAME OR PROGRAM NAME</p>
                                                    <input className="in" type="text" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 border-left border-bottom border-right d-f">
                                            <div className="row40  ">
                                                <p className="p-d-l-4 padding-top-1px">d. INSURANCE PLAN NAME OR PROGRAM NAME</p>
                                                <input className="t-t-x-2" id="inw18" type="text" value={`${report?.adjusterInfo?.companyName}`} />
                                            </div>
                                            <div className="row20 border-left p-d-l-1 ">
                                                <p className="p-d-l-2 padding-top-1px">10d. CLAIM CODES (Designated by NUCC)</p>
                                                <input className="in" type="text" value={`${report?.adjusterInfo?.insured?.claimCodes}`}/>
                                            </div>
                                            <div className=" row40 border-left p-d-l-1">
                                                <p className="p-d-l-2 padding-top-1px">d. IS THERE ANOTHER HEALTH BENEFIT PLAN?</p>
                                                <div className="inside-d-f-n-jb">
                                                    <input type="checkbox" data-be="chk11dy" />
                                                    <p className="mt5">YES</p>
                                                    <input type="checkbox" data-be="chk11dn" />
                                                    <p className="mt5">NO</p>
                                                    <p className="padding-top-1px Italic">If yes, complete items 9,9a and 9d.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 d-f  border-left border-right">
                                            <div className="row60 p-d-l-2    border-right">
                                                <div className="row100 margin-top-2px ">
                                                    <p id="L-p" className="t-a-c">READ BACK OF FORM BEFORE COMPLETING &amp; SIGNING THIS FORM.</p>
                                                </div>
                                                <p>12. PATIENT'S OR AUTHORIZED PERSON' SIGNATURE I authorize the release of any medical or other infromation necessary to process this claim. I also request payment of government benefits either to myself or to the party who accept assignment below.</p>
                                                <div className="inside-d-f-n-jb">
                                                    <p className="mt5">SIGNED</p>
                                                    <input id="inb-b" type="text" />
                                                    <p className="mt5 m-l20">DATE</p>
                                                    <input id="inb-b" type="text" />
                                                </div>
                                            </div>
                                            <div className="row40 margin-top-2px p-d-l-2">
                                                <p>13. INSURED'S OR AUTHORIZED PERSON'S SIGNATURE I authorize payment of medical benefits to the undersigned physician or supplier for service described below.</p>
                                                <div className="inside-d-f-n-jb">
                                                    <p className="mt10">SIGNED</p>
                                                    <input id="inb-b" type="text" />
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="m0" />
                                        <div className="row100 d-f border-bottom border-left border-right">
                                            <div className="row60 d-f">
                                                <div className="coll60   ">
                                                    <p className="p-d-l-2 padding-top-2px">14. DATE OF CURRENT ILLNESS, INJURY, or PREGNANCY (LMP)</p>
                                                    <div className="inside-d-f-s-b">
                                                        <input id="indate-b-r" data-val="14mm" placeholder="MM" type="text" value={doi?.getMonth() + 1}/>
                                                        <input id="indate" data-val="14dd" placeholder="DD" type="text" value={doi?.getDate()}/>
                                                        <input id="indate-b-l" data-val="14yy" placeholder="YY" type="text" value={doi ? String(doi.getFullYear()).slice(-2) : ''}/>
                                                        <div className="d-f a-i-c">
                                                            <p>QUAL</p>
                                                            <input id="in-b-l-d" type="text" value={"431"}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="coll40 border-left ">
                                                    <p className="p-d-l-2 padding-top-2px">15. OTHER DATE</p>
                                                    <div className="inside-d-f">
                                                        <div className="inside-d-f">
                                                            <p className="margin-top-2px">QUAL</p>
                                                            <input id="in-b-l-r" type="text" data-be="15" />
                                                        </div>
                                                        <input id="indate-b-r" placeholder="MM" type="text" data-be="15mm" />
                                                        <input id="indate" placeholder="DD" type="text" data-be="15dd" />
                                                        <input id="indate-b-l" placeholder="YY" type="text" data-be="15yy" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row40  border-left ">
                                                <p className="p-d-l-2 padding-top-2px">16. DATES PATIENT UNABLE TO WORK IN CURRENT OCCUPATIONS</p>
                                                <div className="inside-d-f ">
                                                    <div className="inside-d-f">
                                                        <p className="margin-top-2px p-d-l-2">FROM</p>
                                                        <input id="indate-b-r" placeholder="MM" type="text" data-be="16mm1" />
                                                        <input id="indate" placeholder="DD" type="text" data-be="16dd1" />
                                                        <input id="indate-b-l" placeholder="YY" type="text" data-be="16yy1" />
                                                    </div>
                                                    <div className="inside-d-f">
                                                        <p className="margin-top-2px">TO</p>
                                                        <input id="indate-b-r" placeholder="MM" type="text" data-be="16mm2" />
                                                        <input id="indate" placeholder="DD" type="text" data-be="16dd2" />
                                                        <input id="indate-b-l" placeholder="YY" type="text" data-be="16yy2" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 d-f border-left  border-bottom border-right ">
                                            <div className="row60 d-f border-right">
                                                <div className="coll60  ">
                                                    <p className="p-d-l-2 padding-top-2px">17. NAME OF REFERRING PROVIDER OR OTHER SOURCE</p>
                                                    <div className="inside-d-f-n-jb">
                                                        <input id="in-b-r" type="text" value={"DN"}/>
                                                        <input className="in" type="text" data-be="17"/>
                                                    </div>
                                                </div>
                                                <div className="coll40 border-left  ">
                                                    <div className="row100 d-f">
                                                        <div className="coll10  border-right ">
                                                            <p>17a</p>
                                                        </div>
                                                        <div className="coll10 border-right ">
                                                        </div>
                                                        <input className="in" type="text" data-be="17a"/>
                                                    </div>
                                                    <div className="row100  d-f b-t-dash">
                                                        <div className="coll10 border-left border-right ">
                                                            <p>17b</p>
                                                        </div>
                                                        <div className="coll10  border-right">
                                                            <p>NPI</p>
                                                        </div>
                                                        <input className="in" type="text" data-be="17b"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row40 ">
                                                <p className="p-d-l-2 padding-top-2px">18. HOSPITALIZATION DATES RELATED TO CURRENT SERVICES</p>
                                                <div className="inside-d-f ">
                                                    <div className="inside-d-f">
                                                        <p className="margin-top-2px">FROM</p>
                                                        <input id="indate-b-r" placeholder="MM" type="text" data-be="18mm1" />
                                                        <input id="indate" placeholder="DD" type="text" data-be="18dd1" />
                                                        <input id="indate-b-l" placeholder="YY" type="text" data-be="18yym1" />
                                                    </div>
                                                    <div className="inside-d-f">
                                                        <p className="margin-top-2px">TO</p>
                                                        <input id="indate-b-r" placeholder="MM" type="text" data-be="18mm2" />
                                                        <input id="indate" placeholder="DD" type="text" data-be="18dd2" />
                                                        <input id="indate-b-l" placeholder="YY" type="text" data-be="18yy2" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 border-left border-bottom border-right d-f">
                                            <div className="coll60 border-right ">
                                                <p className=" margin-top-2px padding-left-2px">19. ADDITIONAL CLAIM INFROMATION (Designated by NUCC)</p>
                                                <input className="in" type="text" data-be="19" />
                                            </div>
                                            <div className="coll40  d-f">
                                                <div className="inside">
                                                    <p className="p-d-l-2 padding-top-2px">20. OUTSIDELAB?</p>
                                                    <div className="inside-d-f-n-jb border-right">
                                                        <input type="checkbox" data-be="chk20y" />
                                                        <p className="mt5">YES</p>
                                                        <input type="checkbox" data-be="chk20n" />
                                                        <p className="mt5">NO</p>
                                                    </div>
                                                </div>
                                                <div className="inside d-b t-a-c padding-top-2px ">
                                                    <p>$ CHARGES</p>
                                                    <input className="in" type="text" data-be="20a" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100  border-left border-bottom border-right d-f">
                                            <div className="coll60 border-right illness">
                                                <p className="p-d-l-2 padding-top-2px">21.  DIAGNOSIS IR NATURE OF ILLNESS OR INJURY Relate A-L to service line below (24E)</p>
                                                {
                                                    [0, 1, 2].map((rowIndex) => (
                                                        <div key={rowIndex} className="inside-d-f">
                                                            {
                                                                [0, 1, 2, 3].map((colIndex) => {
                                                                    const label = String.fromCharCode(rows[counter].charCodeAt(0));
                                                                    counter += 1;
                                                                    return (
                                                                        <div key={colIndex} className="inside-d-f-n-jb">
                                                                            <p className="padding-right-2px">{label}</p>
                                                                            <input className="in24E"
                                                                                data-label={label}
                                                                                type="text"
                                                                                defaultValue=""
                                                                            />
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className="coll40  ">
                                                <div className="row100 d-f  border-bottom ">
                                                    <div className="coll40 border-right ">
                                                        <p className="p-d-l-2 padding-top-2px">22.RESUBMISSION CODE</p>
                                                        <input className="in" type="text" data-be="22" />
                                                    </div>
                                                    <div className="coll60  ">
                                                        <p className="p-d-l-2 padding-top-2px">ORIGINAL REF.NO</p>
                                                        <input className="in" type="text" data-be="22a" />
                                                    </div>
                                                </div>
                                                <div className="row100 ">
                                                    <p className="p-d-l-2 padding-top-2px">23. PRIOR AUTHORIZATION NUMBER</p>
                                                    <input className="in" type="text" data-be="23" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 d-f border-left border-bottom border-right">
                                            <div className="row60 d-f">
                                                <div className="coll30 border-right ">
                                                    <p className="p-d-l-2 padding-top-2px">24. A. DATE(S) OF SERVICE</p>
                                                    <div className="inside-d-f-s-a m0">
                                                        <p className="m0">FROM</p>
                                                        <p className="m0">TO</p>
                                                    </div>
                                                    <div className="inside-d-f-s-a padding-top-2px">
                                                        <div className="inside-d-f-s-a ">
                                                            <p>MM&nbsp;</p>
                                                            <p>DD &nbsp;</p>
                                                            <p>YY</p>
                                                        </div>
                                                        <div className="inside-d-f-s-a ">
                                                            <p>MM</p>
                                                            <p>&nbsp; DD</p>
                                                            <p>&nbsp; YY</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="coll10  t-a-c border-right">
                                                    <p className="padding-top-2px ">B. PLACE OF SERVICE</p>
                                                </div>
                                                <div className="coll10 border-right  t-a-c">
                                                    <p className="padding-top-2px">C. EMG</p>
                                                </div>
                                                <div className="coll30 border-right t-a-c padding-top-2px m0">
                                                    <p id="m0">D. PROCEDURES, SERVICES, OR SUPLIES</p>
                                                    <p id="m0">(Explain Unusual Oircumstances)</p>
                                                    <div className="inside-d-f-s-a ">
                                                        <div className="coll50 t-a-c">
                                                            <p id="m0">OPT/HCPCS</p>
                                                        </div>
                                                        <div className="coll50 t-a-c ">
                                                            <p id="m0">MODIFIER</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="coll20 padding-top-2px t-a-c ">
                                                    <p >E.DIAGNOSIS POINTER</p>
                                                </div>
                                            </div>
                                            <div className="row40 d-f border-left border-right  ">
                                                <div className="coll30 t-a-c   ">
                                                    <p className="padding-top-2px">F. $CHARGES</p>
                                                </div>
                                                <div className="coll20 t-a-c  border-left ">
                                                    <p className="padding-top-2px">G.DAYS OR UNITS</p>
                                                </div>
                                                <div className="coll10 t-a-c  mr4  border-left ">
                                                    <p className="p-d-l-2">H.EPSD T Family Plan</p>
                                                </div>
                                                <div className="coll10 t-a-c padding-top-1px  border-left  padding-6px">
                                                    <p >I.ID.QUAL</p>
                                                </div>
                                                <div className="coll30 t-a-c padding-top-1px  border-left  ">
                                                    <p className="padding-top-2px">J.RENDERING PROVIDER ID. #</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 border-left border-right">
                                            <div className="row100 middle6">
                                                {
                                                    middle6Rows.map((rowIndex) => (
                                                        <div key={rowIndex} className={`middle6_${rowIndex}`}>
                                                            <div className="row100 hg1 bg-1 ">
                                                                <input id="bg-1-in" type="text" data-exclude="true" />
                                                            </div>
                                                            <div className="row100 d-f border-bottom">
                                                                <div className="coll60 d-f">
                                                                    <div className="coll30 d-f">
                                                                        <div className="coll16 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                        <div className="coll16 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                        <div className="coll16 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                        <div className="coll16 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                        <div className="coll16 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                        <div className="coll16 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll10 d-f">
                                                                        <div className="coll100 hg1 b-r-dash">
                                                                            <input className="in" type="text"/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll10 d-f">
                                                                        <div className="coll00 hg1 b-r-dash">
                                                                            <input className="in" type="text" data-exclude="true" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll30 d-f">
                                                                        <div className="coll50 hg1 b-r-dash">
                                                                            <input className="in" type="text" data-exclude="true"  />
                                                                        </div>
                                                                        <div className="coll50 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll20 d-f">
                                                                        <div className="coll100 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="coll40  d-f">
                                                                    <div className="coll30 d-f">
                                                                        <div className="coll50 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                        <div className="coll50 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll20 d-f">
                                                                        <div className="coll100 hg1 b-r-dash">
                                                                            <input className="in" type="text" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll10 d-f">
                                                                        <div className="coll100 hg1 b-r-dash">
                                                                            <input className="in" type="text" data-exclude="true" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll10 b-t-dash d-f">
                                                                        <div className="coll100 hg1 b-r-dash t-a-c">
                                                                            <p>NPI</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="coll30 b-t-dash d-f ">
                                                                        <div className="coll100 hg1  ">
                                                                            <input className="in" type="text" data-exclude="true" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        <div className="row100 d-f border-left border-right border-bottom">
                                            <div className="row60 d-f border-right">
                                                <div className="coll40 border-right ">
                                                    <div className="inside-d-f-s-a">
                                                        <p className="padding-top-2px">25. FEDERAL TAX I.D. NUMBER</p>
                                                        <p className="padding-top-2px">SSN</p>
                                                        <p className="padding-top-2px">EIN</p>
                                                    </div>
                                                    <div className="inside-d-f-n-jb">
                                                        <input className="margin-top-10 in" type="text" value={`${report?.appointment?.physicianDoc?.physicianEIN || ""}`} />
                                                        <input className="margin-top-10" data-val="chk25ssn" type="checkbox" checked={report?.appointment?.physicianDoc?.physicianEIN && report?.appointment?.physicianDoc?.physicianEINType === "SSN"} />
                                                        <input className="margin-top-10" data-val="chk25ein" type="checkbox" checked={report?.appointment?.physicianDoc?.physicianEIN && report?.appointment?.physicianDoc?.physicianEINType === "EIN"} />
                                                    </div>
                                                </div>
                                                <div className="coll40 border-right ">
                                                    <p className="p-d-l-2 padding-top-2px ">26. PATIENT'S ACCOUNT NO</p>
                                                    <input className="margin-top-10 in" type="text" data-be="26" />
                                                </div>
                                                <div className="coll20 t-a-c  ">
                                                    <p className="padding-top-2px">27. ACCEPT ASSIGNMENT?
                                                        (For govt claims, see back)
                                                    </p>
                                                    <div className="inside-d-f-s-a">
                                                        <input type="checkbox" data-be="chk27y" />
                                                        <p className="mt5">YES</p>
                                                        <input type="checkbox" data-be="chk27n" />
                                                        <p className="mt5">NO</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row40 d-f ">
                                                <div className="coll30-3  ">
                                                    <div className="inside-d-f-s-a">
                                                        <p className="p-d-l-2 padding-top-2px">28. TOTAL CHARGE</p>
                                                        <input type="checkbox" data-be="chk28" />
                                                    </div>
                                                    <div className="inside-d-f-n-jb ">
                                                        <p className="margin-top-2px">$</p>
                                                        <input className="margin-top-2px in" data-be="28"  type="text" />
                                                    </div>
                                                </div>
                                                <div className="coll30-3 border-left margin-left--2px">
                                                    <p className="p-d-l-2 padding-top-2px">29. AMOUNT PAID</p>
                                                    <div className="inside-d-f-s-a">
                                                        <p className="mt10">$</p>
                                                        <input className="margin-top-10 in" type="text" data-be="29" />
                                                    </div>
                                                </div>
                                                <div className="coll30-3 border-left margin-left--2px">
                                                    <p className="p-d-l-2 padding-top-2px">30. Rsvd.for NUCC Use</p>
                                                    <input className="margin-top-10 in" data-be="30" type="text" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row100 d-f border-left border-right border-bottom">
                                            <div className="coll60 d-f">
                                                <div className="coll40   ">
                                                    <p className="p-d-l-2 padding-top-2px">31. SIGNATURE OF PHYSICIAN OR SUPPLIER INCLUDING DEGREES OR CREDWNTIALS (I certify that statements on the reverse apply to this bill and are made a part thereof.)</p>
                                                    <input className="in" data-val="31sign" type="text" value={report?.appointment?.doctorName}/>
                                                    <div className="inside-d-f-s-a">
                                                        <p className="p-d-l-2 padding-top-12px">SIGNED</p>
                                                        <div className="inside-d-b">
                                                        <input className="in" type="text" data-val="31signdate" value={moment(report?.appointment?.visitDate).format('DD/MM/YYYY')}/>
                                                            <p className="padding-left-80">DATE</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="coll60  border-left ">
                                                    <p className="p-d-l-2 padding-top-2px">32. SERVICE FACILITY LOCATION INFROMATION</p>
                                                    <input className="in" data-val="32office" type="text" value={report?.appointment?.officeName}/>
                                                    <input className="in" data-val="32address" type="text" value={officeDetails?.officeAddress}/>
                                                    <div className="inside-d-f-n-jb padding-top-14px border-top">
                                                        <div className="coll50 d-f">
                                                            <p className="mt5 p-d-l-2">a.</p>
                                                            <input className="in" data-val="32npi" type="text" value={report?.appointment?.officeAddress?.npi} />
                                                        </div>
                                                        <div className="coll50 d-f">
                                                            <p className="mt5 p-d-l-2">b.</p>
                                                            <input className="in" type="text" data-be="32b" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="coll40 border-left ">
                                                <p className="p-d-l-2 balancer">33. BULLING PROVIDER INFO &amp; PH#</p>
                                                <div className="inside-d-f-s-a">
                                                    <input className="t-t-x-2" id="in-area-code" type="text" value={"585"}/>
                                                    <input className="in" type="text" value={"738-8317"}/>
                                                </div>
                                                <input className="in" type="text" value={"Right Script Services"}/>
                                                <input className="in" type="text" value={"PO box 1225, Webster NY 14580"}/>

                                                <div className="inside-d-f-n-jb padding-top-14px border-top">
                                                    <div className="coll50 d-f">
                                                        <p className="mt5 p-d-l-2">a.</p>
                                                        <input className="in" type="text" value={report?.appointment?.officeAddress?.npi} />
                                                    </div>
                                                    <div className="coll50 d-f">
                                                        <p className="mt5 p-d-l-2">b.</p>
                                                        <input className="in" type="text" data-be="33b" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="right-text d-f">
                                            <svg width={20} height={138} viewBox="0 0 20 138" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 0 L20 20 L10 10 L0 20 Z" fill="rgb(182 32 48)" />
                                                <rect x={9} y={10} width={2} height={100} fill="rgb(182 32 48)" />
                                            </svg>
                                            <p >PHYSICIAN OR SUPPLIER INFORMATION</p>
                                            <svg className="arrow-tow" width={20} height={138} viewBox="0 0 20 138" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 0 L20 20 L10 10 L0 20 Z" fill="rgb(182 32 48)" />
                                                <rect x={9} y={10} width={2} height={100} fill="rgb(182 32 48)" />
                                            </svg>
                                        </div>
                                        <div className="right-text-tow d-f">
                                            <svg width={20} height={138} viewBox="0 0 20 138" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 0 L20 20 L10 10 L0 20 Z" fill="rgb(182 32 48)" />
                                                <rect x={9} y={10} width={2} height={60} fill="rgb(182 32 48)" />
                                            </svg>
                                            <p >PATIENT AND INSURED INFORMATION</p>
                                            <svg className="arrow-three" width={20} height={138} viewBox="0 0 20 138" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 0 L20 20 L10 10 L0 20 Z" fill="rgb(182 32 48)" />
                                                <rect x={9} y={10} width={2} height={60} fill="rgb(182 32 48)" />
                                            </svg>
                                        </div>
                                        <div className="bottom-text-three d-f-s-b">
                                            <p >NUCC Instruction Manual available at: www.nucc.org</p>
                                            <p className="bottom-middle-text"> PLEASE PRINT OR TYPE</p>
                                            <p> APPROVED OMB-0938-1197 1500 (02-12)</p>
                                        </div>
                                        <div className="invoice-button-container">
                                            <Button type='primary' variant="contained" className="invoice-edit-button" onClick={()=> handleSaveInvoice(false)}>Save</Button>
                                            <Button type='primary' variant="contained" className="invoice-print-button" onClick={() => handleSaveInvoice(true)}>
                                                Save And Print
                                            </Button>
                                            <Button type='primary' variant="contained" className="invoice-print-button" onClick={handleSaveAsPdf}>
                                                {loading? "saving..." : "Save As PDF"}
                                            </Button>
                                            <Button type='primary' variant="contained" className="invoice-print-button" onClick={handleSendToCarisk}>
                                                {loading? "sending..." : "Send to Carisk"}
                                            </Button>
                                            <Button type='primary' variant="contained" className="invoice-print-button" onClick={downloadCsvForCarisk(claimId)}>
                                                {loading? "sending..." : "Download csv for Carisk"}
                                            </Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )
                    )
            }
        </>
    );
}

export default Invoice;